import { render, staticRenderFns } from "./LoggedRegisterProcessOnPublic.vue?vue&type=template&id=3c97537c&scoped=true&"
import script from "./LoggedRegisterProcessOnPublic.vue?vue&type=script&lang=js&"
export * from "./LoggedRegisterProcessOnPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97537c",
  null
  
)

export default component.exports